<!-- Main container -->
<div class="layout-col full">
  <elder-table class="flex" matSort [data]="data" (itemClick)="openDetail($event, company())">
    @if (canAdd() || canRemove()) {
      <elder-data-toolbar
        *elderTableToolbar
        (requestNew)="onRequestNew()"
        [canRemove]="canRemove()"
        [canAdd]="canAdd()"
        [canMore]="false"
      >
      </elder-data-toolbar>
    }

    <!-- icon -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
      <td mat-cell *matCellDef="let row">
        <div class="layout-row place-start-center">
          <mat-icon>featured_video</mat-icon>
        </div>
      </td>
    </ng-container>

    <!-- number Column -->
    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.number' | translate }}
      </th>
      <td mat-cell *matCellDef="let pkg">{{ pkg.number }}</td>
    </ng-container>

    <!-- type Column -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.type' | translate }}
      </th>
      <td mat-cell *matCellDef="let pkg">{{ pkg.type ? pkg.type.name : pkg.typeId }}</td>
    </ng-container>

    <!-- state Column -->
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.state' | translate }}
      </th>
      <td mat-cell *matCellDef="let pkg">{{ 'packages.state.' + pkg.state | translate }}</td>
    </ng-container>

    <!-- dispatchState Column -->
    <ng-container matColumnDef="dispatchState">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'packages.dispatchState.title' | translate }}
      </th>
      <td mat-cell *matCellDef="let pkg">
        {{ 'packages.dispatchState.' + pkg.dispatchState.state | translate }}
      </td>
    </ng-container>

    <!-- location Column -->
    <ng-container matColumnDef="location">
      <th
        mat-header-cell
        *matHeaderCellDef
        style="width: 10%"
        mat-sort-header="location.storagePath"
      >
        {{ 'shopfloor.storage.location' | translate }}
      </th>
      <td mat-cell *matCellDef="let pkg">{{ pkg.location?.storagePath }}</td>
    </ng-container>

    <!-- weight Column -->
    <ng-container matColumnDef="weight">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" elderNumberCell>
        {{ 'context.weight' | translate }}
      </th>
      <td mat-cell *matCellDef="let pkg" elderNumberCell>{{ pkg.weight | elderQuantity }}</td>
    </ng-container>

    <!-- hints Column -->
    <ng-container matColumnDef="hints">
      <th mat-header-cell *matHeaderCellDef style="width: 10%">
        {{ 'context.hints' | translate }}
      </th>
      <td mat-cell *matCellDef="let pkg">
        <div class="layout-row place-start-center">
          @if (pkg.containsPartialItems) {
            <mat-icon [matTooltip]="'packages.partialItems' | translate"> announcement </mat-icon>
          }
        </div>
      </td>
    </ng-container>

    <!-- contentDescription Column -->
    <ng-container matColumnDef="contentDescription">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'packages.contentDescription' | translate }}
      </th>
      <td mat-cell *matCellDef="let pkg">{{ pkg.contentDescription }}</td>
    </ng-container>
  </elder-table>
</div>
